module.exports = __webpack_public_path__ + "static/media/kpay_logo.36ee2974.svg";